import { useSuspenseQuery } from '@tanstack/react-query';

import { tagKeys } from '@/shared/lib/query/queryKeys';

import { getTagDetailApi } from '@/entities/tags/api';

type UseTagDetailParams = {
  tagName: string;
};

export const useTagDetail = ({ tagName }: UseTagDetailParams) => {
  return useSuspenseQuery({
    queryKey: tagKeys.tagDetail(tagName),
    queryFn: () => getTagDetailApi(tagName),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
